var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmagineProfilo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D0D6E9;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_236_6_",
    className: "st0",
    cx: 30,
    cy: 30,
    r: 29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,29.8C17.5,29.8,17.5,29.8,17.5,29.8c0,6.9,5.6,12.5,12.5,12.5c6.9,0,12.5-5.6,12.5-12.5 c0-6.9-5.6-12.5-12.5-12.5C23.1,17.3,17.5,22.9,17.5,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,59c8.1,0,15.3-3.3,20.6-8.6c-2-3.2-5.5-5.3-9.5-5.3h-4.8c-4,1.9-8.6,1.9-12.7,0h-4.8 c-4,0-7.5,2.1-9.5,5.3C14.7,55.7,21.9,59,30,59z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmagineProfilo);
export default __webpack_public_path__ + "static/media/immagine_profilo.dfa4b9c58bbca3797266462446d60f89.svg";
export { ForwardRef as ReactComponent };